exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home-interiors-locateus .text-container{margin-top:4%;margin-bottom:4%}.home-interiors-locateus .text-container .text-wrapper{display:block;margin:auto;width:80%;text-align:center}.home-interiors-locateus .text-container .text-wrapper div{font-size:18px}\n", ""]);

// exports
